export const FormatDateJson = (date, reg = -1) => {
  if (date === null || date === "" || typeof date === "undefined") return "N/A";

  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    h = d.getHours(),
    m = d.getMinutes(),
    s = d.getSeconds();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (h < 10) h = "0" + h;
  if (m < 10) m = "0" + m;
  if (s < 10) s = "0" + s;

  switch (reg) {
    case 1:
      return `${day}/${month}/${year}`;
    case 2:
      return `${year}-${month}`;
    case 3:
      return `${month}/${day}/${year} ${h}:${m}:${s}`;
    case 4:
      return `${month}/${day}/${year}`;
    case 5: // Định dạng MM/DD/YYYY
      return `${month}/${day}/${year}`;
    case 6: // Đầu giờ: MM/DD/YYYY 00:00:00
      return `${month}/${day}/${year} 00:00:00`;
    case 7: // Cuối giờ: MM/DD/YYYY 23:59:59
      return `${month}/${day}/${year} 23:59:59`;
    case 8: //them danh cho truong hop login moi
      return [year, month, day].join("-") + " " + [h, m].join(":");
    default:
      return `${day}/${month}/${year} ${h}:${m}`; // Giá trị mặc định
  }
};
